/**
 * Cliente do services/validador-anuncios. Same-origin — sessão S2 via nginx auth_request;
 * as POSTs levam X-Token injectado só no servidor (o browser nunca vê).
 */
import type { Estado, EstadoQualidade, ValidadorDados, ValidadorStatus } from './types'

export class ValidadorApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.name = 'ValidadorApiError'
    this.status = status
  }
}

const BASE = '/api/validador-anuncios'

async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  const resp = await fetch(BASE + path, {
    credentials: 'include',
    ...init,
    headers: { Accept: 'application/json', ...(init?.body ? { 'Content-Type': 'application/json' } : {}), ...init?.headers },
  })
  if (!resp.ok) {
    const corpo = (await resp.json().catch(() => null)) as { erro?: string; detail?: string } | null
    throw new ValidadorApiError(
      resp.status,
      corpo?.erro ||
        (typeof corpo?.detail === 'string' ? corpo.detail : undefined) ||
        `Falha no serviço do Validador (HTTP ${resp.status}).`,
    )
  }
  return resp.json() as Promise<T>
}

export function fetchValidadorDados(): Promise<ValidadorDados> {
  return apiJson('/dados')
}

export function fetchValidadorStatus(): Promise<ValidadorStatus> {
  return apiJson('/status')
}

/** Análise completa (todas as lojas, ~30–60 min). */
export function dispararAnalise(): Promise<{ ok: boolean; mensagem?: string }> {
  return apiJson('/atualizar', { method: 'POST' })
}

/** Reanalisa um anúncio na hora (divergências + qualidade, sem IA). `loja` = loja_key. */
export function conferirAnuncio(
  id: string,
  loja: string,
): Promise<{ ok: boolean; diverge: boolean; mudou: boolean; estado: Estado | null; nota?: string | null; estado_qualidade?: EstadoQualidade | null; erro_qualidade?: string | null }> {
  return apiJson('/conferir', { method: 'POST', body: JSON.stringify({ id, loja }) })
}

export function marcarAnuncio(
  id: string,
  loja: string,
  acao: 'corrigido' | 'falso' | 'desfazer',
  por: string,
): Promise<{ ok: boolean; estado: Estado }> {
  return apiJson('/marcar', { method: 'POST', body: JSON.stringify({ id, loja, acao, por }) })
}

export function marcarQualidade(
  id: string,
  loja: string,
  acao: 'corrigido' | 'ignorar' | 'desfazer',
  por: string,
): Promise<{ ok: boolean; estado: EstadoQualidade }> {
  return apiJson('/marcar-qualidade', { method: 'POST', body: JSON.stringify({ id, loja, acao, por }) })
}
